import React, { useState } from 'react';
import aboutBottom from '../../../assets/banner_imgaes/aboutBottom.jpg';
import aboutTop from '../../../assets/banner_imgaes/aboutTop.png';
import aboutDefault from '../../../assets/banner_imgaes/aboutDefault.png';
import aboutDefaultText from '../../../assets/banner_imgaes/aboutDefaultText.svg';
import './banner.css';

export const AboutUs = () => {
  const [key, setKey] = useState('default');

  const handleMouseEnter = (newKey) => {
    setKey(newKey);
  };

  const handleMouseLeave = () => {
    setKey('default'); // 默认状态
  };

  return (
    <div
      style={{
        height: 436,
        display: 'flex',
        flexWrap: 'nowrap',
        position: 'relative',
        marginTop: 64,
        background: '#666',
      }}
    >
      <img
        src={aboutTop}
        alt="Top"
        className={`background-image ${key === 'top' ? 'active' : ''}`}
      />
      <img
        src={aboutBottom}
        alt="Bottom"
        className={`background-image ${key === 'bottom' ? 'active' : ''}`}
      />
      <div
        className={'banner-aboutUs-left'}
        style={{ flex: '50%', zIndex: 1, color: '#fff' }}
      >
        {(() => {
          switch (key) {
            case 'default':
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    minWidth: 720,
                  }}
                >
                  <img
                    src={aboutDefault}
                    alt="Default"
                    className="background-image active"
                    style={{
                      zIndex: 1,
                      objectFit: 'cover',
                      objectPosition: 'center',
                    }}
                  />
                  <img src={aboutDefaultText} alt="" style={{ zIndex: 2 }} />
                </div>
              );
            case 'top':
              return (
                <div
                  style={{
                    padding: '36px 90px 0 120px',
                    fontSize: 16,
                    lineHeight: 1.7,
                    width: 720,
                    marginLeft: 'auto',
                  }}
                >
                  <div>
                    天津挚云数字科技有限公司（简称：挚云数科）于2020年4月成立，注册资本金1000万元，是行业领先的供应链金融科技解决方案提供商，天津市商业保理协会副会长单位。
                  </div>
                  <br />
                  <div>
                    挚云数科坚持科技 +
                    运营的理念，专注于为保理公司提供专业、高效的供应链金融科技系统与运营服务，服务包括实体企业、第三方机构及金融机构在内的参与各方，致力于构建覆盖供应链金融全流程的生态系统。
                  </div>
                  <br />
                  <div>
                    挚云数科具备行业领先的供应链金融科技研发实力与运营能力，基于保理公司、大型央企、国企以及A股上市公司等优质企业客户的供应链正、反向保理融资项目实际需求，针对业务痛点、难点，依托私有云、AI、区块链、大数据等技术手段，提供专业的服务。
                  </div>
                </div>
              );
            case 'bottom':
              return (
                <div
                  style={{
                    paddingLeft: 120,
                    display: 'flex',
                    height: '100%',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: 720,
                    marginLeft: 'auto',
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 26,
                        marginBottom: 8,
                        fontWeight: 'bold',
                      }}
                    >
                      使命
                    </div>
                    <div style={{ fontSize: 18 }}>
                      让供应链金融科技惠及链上企业
                    </div>
                  </div>
                  <div style={{ margin: '32px 0' }}>
                    <div
                      style={{
                        fontSize: 26,
                        marginBottom: 8,
                        fontWeight: 'bold',
                      }}
                    >
                      愿景
                    </div>
                    <div style={{ fontSize: 18 }}>
                      打造开放协同的供应链金融科技生态体系
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: 26,
                        marginBottom: 8,
                        fontWeight: 'bold',
                      }}
                    >
                      价值观
                    </div>
                    <div style={{ fontSize: 18 }}>
                      承诺、勇气、专注、开放、尊重
                    </div>
                  </div>
                </div>
              );
          }
        })()}
      </div>
      <div
        className={'banner-aboutUs-right'}
        style={{ flex: '50%', zIndex: 1 }}
      >
        <div
          className={'banner-aboutUs-right-Desc'}
          onMouseEnter={() => handleMouseEnter('top')}
          onMouseLeave={handleMouseLeave}
          style={{
            height: '50%',
            background: key === 'top' ? 'transparent' : '#2C2C2C',
            color: key === 'top' ? '#fff' : '#666666',
          }}
        >
          <div
            style={{
              borderBottom: `2px solid ${key === 'top' ? '#fff' : '#666'}`,
            }}
          >
            Company Introduction
          </div>
          <div>公司介绍</div>
        </div>
        <div
          className={'banner-aboutUs-right-Desc'}
          onMouseEnter={() => handleMouseEnter('bottom')}
          onMouseLeave={handleMouseLeave}
          style={{
            height: '50%',
            background: key === 'bottom' ? 'transparent' : '#2C2C2C',
            color: key === 'bottom' ? '#fff' : '#666666',
          }}
        >
          <div
            style={{
              borderBottom: `2px solid ${key === 'bottom' ? '#fff' : '#666'}`,
            }}
          >
            Mission and Vision
          </div>
          <div>使命和愿景</div>
        </div>
      </div>
    </div>
  );
};
